import script from "./ConnectSocialDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectSocialDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ConnectSocialDialog.vue?vue&type=style&index=0&id=1a34f55a&lang=sass"

const __exports__ = script;

export default __exports__